import { Link } from 'react-router-dom';
import '../../../App.css';
import Cards from './cards';
import CardJesus from './cardJesus';

const Equipe = () => {
    return (
        // < !--Team Start-- >
        <div className="container-fluid team py-5">
            <div className="container">
                <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="sub-style">
                        <h4 className="sub-title px-3 mb-0">Conheça nossa equipe</h4>
                    </div>
                    <h1 className="display-3 mb-4">Servindo com Propósito, Trabalhando com Amor</h1>
                    {/* <p className="mb-0">Texto sobre a equipe</p> */}
                </div>
                <div className="row g-8 justify-content-center mb-3">
                    <CardJesus />
                </div>

                <Cards equipeCompleta={false} />

            </div>
            <div className="col-12 pt-5 text-center wow fadeInUp" data-wow-delay="0.2s">
                <Link to="/Equipe" className="btn btn-primary rounded-pill text-white py-3 px-5">Conhecer Equipe</Link>
            </div>
            {/* <!--Team End-- > */}
        </div>
    )
};

export default Equipe;